export const calendarSingleMocks = {
  today: '6/7/2019',
  selectedDate: '6/8/2019',
  monthLabel: 'May',
  yearLabel: '2019',
  mode: {
    type: 'select',
    options: {
      single: 'single',
      double: 'double'
    }
  },
  disablePrevious: false
};
